import { Box, Typography } from "@material-ui/core";
import React from "react";

import {
  ANXIETY_LEVELS,
  ANXIETY_ROWS,
  DIAGNOSIS_QUESTION_TEXT,
} from "@/constants/investmentStyleDiagnosisQuestions";
import type { AnxietyKey } from "@/types/investmentStyleDiagnosis";

import { DiagnosisInvestmentStyleAnxietyMatrix } from "../DiagnosisInvestmentStyleAnxietyMatrix";

import { useStepStyles } from "./stepStyles";

type AnxietyStepProps = {
  anxiety: Partial<Record<AnxietyKey, string>>;
  onAnxietyChange: (key: AnxietyKey, level: string) => void;
};

const AnxietyStep: React.FC<AnxietyStepProps> = ({ anxiety, onAnxietyChange }) => {
  const classes = useStepStyles();
  return (
    <>
      <Typography className={classes.title}>今感じている不安について</Typography>
      <Typography className={classes.description}>{DIAGNOSIS_QUESTION_TEXT[11]}</Typography>
      <Box className={classes.inputArea}>
        <DiagnosisInvestmentStyleAnxietyMatrix
          rows={ANXIETY_ROWS}
          levels={ANXIETY_LEVELS}
          values={anxiety}
          onChange={(key, level) => onAnxietyChange(key as AnxietyKey, level)}
        />
      </Box>
    </>
  );
};

export default AnxietyStep;
